import * as ActionTypes from '../actionTypes';

// API
import * as HttpApi from '../Api/index';

export const actionTypes = ActionTypes;

//////////////////
///// GET ////////
//////////////////
export const getList = (params) => {
	return (dispatch) => {
		return HttpApi.get('eCOMPANY_LIST', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const getCount = (params) => {
	return (dispatch) => {
		return HttpApi.get('GET_ACCOUNT_COUNT', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const getById = (params) => {
	return (dispatch) => {
		return HttpApi.get('eCOMPANY_GET', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const getCodeCheckList = (params) => {
	return (dispatch) => {
		return HttpApi.get('eCOMPANY_CODE_CHECK_LIST', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

//////////////////
///// POST ///////
//////////////////
export const create = (params) => {
	return (dispatch) => {
		return HttpApi.post('eCOMPANY_CREATE', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

//////////////////
///// PUT  ///////
//////////////////
export const updateAdmin = (params) => {
	return (dispatch) => {
		return HttpApi.put('eCOMPANY_UPDATE', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const updateStatus = (params) => {
	return (dispatch) => {
		return HttpApi.put('eCOMPANY_UPDATE_EUserStatus', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

//////////////////
///// DELETE /////
//////////////////
export const remove = () => {
    return (dispatch) => {
        return HttpApi.del('eCOMPANY_DELETE')
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
};

//////////////////
/// FUNCTIONS ////
//////////////////
export const session = () => {
    return (dispatch) => {
        return HttpApi.get('eSESSION')
            .then((response) => {
                console.log(response);
                dispatch({ type: ActionTypes.eCOMPANY, eCOMPANY: response.data });
                return Promise.resolve(response.data);
            })
            .catch((err) => {
                console.log(err);
                return Promise.reject(err);
            });
    };
};
export const login = (params) => {
	return (dispatch) => {
		return HttpApi.post('eCOMPANY_LOGIN', params)
			.then((response) => {
				dispatch({ type: ActionTypes.LOGIN, author: response.data });
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};
